import {BASE_URL} from '../../env.js';

export const getApi = async (url) => {
    let data;
    try {
        data = await fetch(BASE_URL + url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': getToken(),
            },
        });
    } catch (e) {
        return {
            "success": false,
            "data": null
        };
    }
    if (data.status === 200) {
        data = await data.json();
        return {
            "success": true,
            "data": data
        };
    }
    return {
        "success": false,
        "data": data
    };
}

export const postApi = async (url, body) => {
    let data;
    try {
        data = await fetch(BASE_URL + url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': getToken(),
            },
            body: JSON.stringify(body),
        })
    } catch (e) {
        return {
            "success": false,
            "data": null
        };
    }
    if (data.status === 200) {
        data = await data.json();
        return {
            "success": true,
            "data": data
        };
    }
    return {
        "success": false,
        "data": data
    };
}

const getToken = () => {
    //TODO: Dynamic Token allocation
    return 'Bearer ' + 
    'yJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0YzQ3NTI4ZGZiY2JlMTUxMDU1ZDg3NGNlNzQ5ZDI0MyIsImp0aSI6IjZmYjIyMTgyZmExNGQ2OTNjZTI4ZmVmY2FlM2FlNWMzZWRhYTAyYTUxMjkwM2ZkY2Q0NmNlNGMwZjM4MzI1NjkwODY5NjRjMDM3M2FiOGFjIiwiaWF0IjoxNjI1MTU1OTc0LjI1MzQzMSwibmJmIjoxNjI1MTU1OTc0LjI1MzQzNywiZXhwIjoxNjU2NjkxOTc0LjIzMDg5OCwic3ViIjoiS2FydW5hIEFkbWluIiwic2NvcGVzIjpbXX0.HY07uEka9AoOmJf28zxz9umm2vdsKxwyIQmHMjrMrMYww5D1ZSXZtHo42tJPbKROpvYDtjPbURKz2DlMPWZADD-qJwBCFhuXvqm2x5Kg49MWNYg3LnTgtqUzdAYwtEfFyUpBNGy6CHvu9hPD6vP5BWHb88mbAANrIG0AQoY2uUd7dnq2IsuPGU-fr-3NrjUIrIY2Z90hhPwyczR6AcPB0l_ySMcQLQDKKXiHH6zym1ZvZqSYq0w9nQ-TadaCbSI1SHBs-TzgrtTRJJwdI-7VvCBezJlEo4rIuEC2Ea8vvvC3yeSEDvi-p4ohX2AY3bjHM2yLJ0hCpeO539FqtNbXZg'
    ;
}

//Server Token: eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0YzQ3NTI4ZGZiY2JlMTUxMDU1ZDg3NGNlNzQ5ZDI0MyIsImp0aSI6IjZmYjIyMTgyZmExNGQ2OTNjZTI4ZmVmY2FlM2FlNWMzZWRhYTAyYTUxMjkwM2ZkY2Q0NmNlNGMwZjM4MzI1NjkwODY5NjRjMDM3M2FiOGFjIiwiaWF0IjoxNjI1MTU1OTc0LjI1MzQzMSwibmJmIjoxNjI1MTU1OTc0LjI1MzQzNywiZXhwIjoxNjU2NjkxOTc0LjIzMDg5OCwic3ViIjoiS2FydW5hIEFkbWluIiwic2NvcGVzIjpbXX0.HY07uEka9AoOmJf28zxz9umm2vdsKxwyIQmHMjrMrMYww5D1ZSXZtHo42tJPbKROpvYDtjPbURKz2DlMPWZADD-qJwBCFhuXvqm2x5Kg49MWNYg3LnTgtqUzdAYwtEfFyUpBNGy6CHvu9hPD6vP5BWHb88mbAANrIG0AQoY2uUd7dnq2IsuPGU-fr-3NrjUIrIY2Z90hhPwyczR6AcPB0l_ySMcQLQDKKXiHH6zym1ZvZqSYq0w9nQ-TadaCbSI1SHBs-TzgrtTRJJwdI-7VvCBezJlEo4rIuEC2Ea8vvvC3yeSEDvi-p4ohX2AY3bjHM2yLJ0hCpeO539FqtNbXZg